import React, { useContext, useEffect, useState } from 'react'
import { Box, Text } from "grommet"

import TTJsonTree from './TTJsonTree'
import { useTTUSAccountExact } from '../../utils/account'
import Spinner from './Spinner'
import { AlertDetailedViewInner } from '../alert/AlertDetailedView'

import { gql, useQuery } from '@apollo/client';
import EnvContext from '../../context/EnvContext'

import AgDataTable from '../common/AgDataTable'
import * as moment from "moment-timezone"
import UserContext from '../../context/UserContext'

import { useConnection } from '../../utils/connection'
import { useFixData } from '../../utils/fix'

export const AccountDetailView = ({ accountId }) => {

    const accountLookup = useTTUSAccountExact(accountId)

    return (
        <>
            {accountLookup && accountId && Object.keys(accountLookup).length > 0 &&
                <TTJsonTree data={accountLookup[accountId]} />
            }
            {(!accountLookup || !accountId || Object.keys(accountLookup).length === 0) &&
                <Spinner />
            }
        </>
    )
}

export const FixDataView = ({ fixSessionId }) => {

    const SESSION_SUBSCRIPTION = gql`
    query ($envName: String!, $fixSessionId: Int!) {
        sessionFixView(where: {
          environmentName: {_eq: $envName}, fixSessionId: {_eq: $fixSessionId}
        }
      ) {
            fixSessionMetrics
        }
    }
    `
    const envSelected = useContext(EnvContext)
    const sessionData = useQuery(
        SESSION_SUBSCRIPTION,
        {
            variables: {
                "envName": envSelected,
                "fixSessionId": fixSessionId
            },
            pollInterval: 1000 * 30
        }
    )

    return (
        <>
            {sessionData && !sessionData.loading && sessionData.data && sessionData.data.sessionFixView && sessionData.data.sessionFixView.length > 0 &&
                <TTJsonTree data={sessionData.data.sessionFixView[0].fixSessionMetrics} />
            }
            {sessionData && !sessionData.loading && sessionData.data && sessionData.data.sessionFixView && sessionData.data.sessionFixView.length === 0 &&
                <TTJsonTree data={{ info: "No Session Data For Fix Session ID " + fixSessionId.toString() }} />
            }
        </>
    )
}

export const NodeServiceView = ({ instance }) => {

    return (

        <AlertDetailedViewInner
            serviceInstanceSelected={instance}
            nodeSelected=""
            nodeTypeSelected=""
            serviceGroupSelected=""
            customOutput=""
        />

    )
}

export const SessionDetailView = ({ sessionData }) => {

    const sessionType = sessionData.sessionType
    const sessionId = sessionData.sessionId
    const env = sessionData.env

    const connectionLookup = useConnection(env, [sessionId], true)
    const companyLookup = useFixData()

    const [jsonData, setjsonData] = useState({})

    useEffect(() => {
        if (connectionLookup && companyLookup) {
            if (sessionType === 'connections' && Object.keys(connectionLookup).length > 0) {
                setjsonData(connectionLookup[sessionId])
            } else {
                setjsonData(companyLookup[sessionId])
            }
        }
    }, [sessionType, connectionLookup, sessionId, companyLookup])

    return (
        <TTJsonTree data={jsonData} />
    )
}

export const SessionHistoryView = ({ sessionData }) => {

    const AGG_QUERY_HISTORY = gql`
    query AggregatedSessionHistoryCombinedView($envName: String!, $sessionId: bigint!, $sessionType: String!) {
        AggregatedSessionHistoryCombinedView(where: {env: {_eq: $envName}, sessionId: {_eq: $sessionId}, sessionType: {_eq: $sessionType}}) {
          nodeName
          sessionId
          sessionInfo
          sessionState
          sessionType
          timestamp
          TTUSenabled
          TTUSenabledByOwner
          TTUSlastUpdatedUserId
          TTUSlastUpdatedDate
          TTUSdeleted
          TTUSAccounts
          source
        }
      }       
    `

    const token = useContext(UserContext)
    const results = useQuery(
        AGG_QUERY_HISTORY, { 
            variables: { "envName": sessionData.env, "sessionId": sessionData.sessionId, "sessionType": sessionData.sessionType },
            pollInterval: 1000 * 30
        }
    )
    const [tab_data, set_tab_data] = useState([])

    let tab_col = [
        {
            field: "timestamp",
            headerName: "Updated",
            sort: 'desc',
            minWidth: 250,
        },
        {
            headerName: "Session Details",
            children: [
                {
                    field: "nodeName",
                    headerName: "Node",
                    minWidth: 150,
                    cellStyle: function (params) {
                        if (params.value === 'NOT FOUND') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                },
                {
                    field: "state",
                    headerName: "State",
                    cellStyle: function (params) {
                        if (params.value !== 'UP') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                    minWidth: 200,
                },
                {
                    field: "source",
                    headerName: "Source",
                    minWidth: 150,
                },
                {
                    field: "sessionInfo",
                    headerName: "Info",
                    minWidth: 450,
                },
            ]
        },
        {
            headerName: "TTUS",
            children: [
                {
                    field: "TTUSenabledByTT",
                    headerName: "TTUS TT Action",
                    cellStyle: function (params) {
                        if (params.value === 'DISABLED') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                    minWidth: 150,
                },
                {
                    field: "TTUSenabledByOwner",
                    headerName: "TTUS Client Action",
                    minWidth: 170,
                    cellStyle: function (params) {
                        if (params.value === 'DISABLED') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                },
                {
                    field: "TTUSdeleted",
                    headerName: "Deleted",
                    cellStyle: function (params) {
                        if (params.value === 'YES') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                    minWidth: 150,
                },
                {
                    field: "TTUSAccounts",
                    headerName: "Has Accounts",
                    cellStyle: function (params) {
                        if (params.value !== 'YES') {
                            return { color: 'white', backgroundColor: '#B4130B' };
                        } else {
                            return { color: 'black', backgroundColor: 'white' };
                        }
                    },
                    minWidth: 150,
                },
            ]
        },
    ]

    useEffect(() => {

        let tab_data_temp = []

        !results.loading && results.data && results.data.AggregatedSessionHistoryCombinedView.forEach(session => {

            const state = session.sessionState === 1 ? "UP" : (session.sessionState === 2 ? "DOWN" : "UNKNOWN")
            let lastUpdated = moment(moment(session.timestamp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            lastUpdated = moment(lastUpdated).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            const TTUSenabledByTT = (session.TTUSenabled === 0 && session.TTUSenabledByOwner === 1) ? "DISABLED" : "ENABLED"

            const data = {
                uniqueId: session.timestamp + session.nodeName,
                id: session.sessionId,
                type: session.sessionType,
                state: state,
                source: session.source ? session.source : "",
                sessionInfo: session.sessionInfo,
                nodeName: session.nodeName,
                timestamp: lastUpdated,
                TTUSlastUpdatedDate: session.TTUSlastUpdatedDate,
                TTUSenabledByOwner: (session.TTUSenabledByOwner === 1 | session.TTUSenabledByOwner === -1) ? "ENABLED" : "DISABLED",
                TTUSenabledByTT: TTUSenabledByTT,
                TTUSdeleted: session.TTUSdeleted === 1 ? "YES" : "NO",
                TTUSAccounts: session.TTUSAccounts === 1 ? "YES" : "NO",
            }
            tab_data_temp.push(data)

            set_tab_data(tab_data_temp)

        })
    }, [results.loading, results.data, token.timezone])

    return (

        <Box fill={true} background="light-2" pad="small">
            <Box pad="small"><Text size="small">Data From Sessions History</Text></Box>

            {tab_data.length === 0 && results.loading &&
                <Spinner />
            }

            {tab_data.length > 0 &&
                <>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="AggSessionsHistory"
                    />
                </>
            }
        </Box>
    )
}
